module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./PayMentView.js"));
	}, "PayMentView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=PayMentView!./src/pages/Shop/PayMent/PayMentView.js
// module id = 888
// module chunks = 431